import React, { useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { FaCalendar } from "react-icons/fa";
import { Container, CustomButton, Placeholder, RodapePicker } from "./style";
import { TimeFields } from "./TimeFields";
import { PrimaryButton } from "components/Button/style";
import br from "date-fns/locale/pt-BR";
import temaPadrao from "_config/temas/estilo/base";

interface IDatePickerProps {
  onChange: (
    date: any,
    event: React.SyntheticEvent<any, Event> | undefined
  ) => void;
  selected?: Date | null | undefined;
  rangeSelect?: boolean;
  startDate?: Date;
  endDate?: Date;
  placeholder?: string;
  mensagemErro?: string;
  dateFormat?: string;
  minDate?: Date;
  maxDate?: Date;
  showTimeSelect?: boolean;
}

interface ICustomInput {
  value?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {};
  children?: React.ReactNode;
  className?: string;
  placeholder?: string;
}

const InputIcon = React.forwardRef<HTMLButtonElement>(
  (props: ICustomInput, ref: React.Ref<HTMLButtonElement>) => (
    <CustomButton
      type="button"
      className="example-custom-input"
      onClick={props.onClick}
      ref={ref}
    >
      <Placeholder selected={!!props.value}>
        {props.value
          ? props.value
          : props.placeholder
          ? props.placeholder
          : "Selecione"}
      </Placeholder>
      <FaCalendar />
    </CustomButton>
  )
);

export function CustomDatePicker({
  onChange,
  selected,
  rangeSelect = false,
  endDate,
  startDate,
  placeholder,
  mensagemErro,
  dateFormat = "dd/MM/yyyy",
  minDate = undefined,
  maxDate = undefined,
  showTimeSelect = false,
}: IDatePickerProps) {
  const [aberto, setAberto] = useState(false);
  const valorAoAbrirRef = useRef<Date | null>(null);

  const abrir = () => {
    valorAoAbrirRef.current = selected ?? null;
    setAberto(true);
  };

  const cancelar = () => {
    onChange(valorAoAbrirRef.current, undefined);
    setAberto(false);
  };

  const confirmar = () => setAberto(false);

  return (
    <Container className={showTimeSelect ? "com-hora" : undefined}>
      <DatePicker
        isClearable
        locale={br}
        dateFormat={dateFormat}
        selected={selected}
        onChange={onChange}
        customInput={<InputIcon />}
        selectsRange={rangeSelect}
        endDate={endDate}
        startDate={startDate}
        minDate={minDate}
        maxDate={maxDate}
        placeholderText={placeholder}
        showTimeInput={showTimeSelect}
        customTimeInput={showTimeSelect ? <TimeFields /> : undefined}
        {...(showTimeSelect
          ? {
              open: aberto,
              onInputClick: abrir,
              onClickOutside: confirmar,
              shouldCloseOnSelect: false,
              showMonthDropdown: true,
              showYearDropdown: true,
              dropdownMode: "select" as const,
              calendarStartDay: 1,
              timeInputLabel: "",
            }
          : {})}
      >
        {showTimeSelect && (
          <RodapePicker>
            <PrimaryButton type="button" onClick={confirmar}>
              Selecionar
            </PrimaryButton>
            <PrimaryButton type="button" outline variante="primary" onClick={cancelar}>
              Cancelar
            </PrimaryButton>
          </RodapePicker>
        )}
      </DatePicker>
      {!!mensagemErro && (
        <p
          style={{
            fontSize: "0.85rem",
            color: temaPadrao.colors.danger.main,
            marginTop: "5px",
          }}
        >
          {mensagemErro}
        </p>
      )}
    </Container>
  );
}
